/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_2Inputs */

const en_flow_order_2 = /** @type {(inputs: Flow_Order_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit, allocation and the confirmation, in Backstage.`)
};

/**
* | output |
* | --- |
* | "Credit, allocation and the confirmation, in Backstage." |
*
* @param {Flow_Order_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_2 = /** @type {((inputs?: Flow_Order_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_2(inputs)
});